export default __webpack_public_path__ + "static/media/aribaTransparent.07a43175.png";